import styled from "@emotion/styled";
import { datePickerTheme } from "./datePickerTheme";
export const DatePickerDayContainer = styled("div")`
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    row-gap: ${_ref => {
  let {
    themeMode
  } = _ref;
  return datePickerTheme.dayRowGap(themeMode);
}};
    margin-top: ${_ref2 => {
  let {
    themeMode
  } = _ref2;
  return datePickerTheme.dayContainerMarginTop(themeMode);
}};
`;
//# sourceMappingURL=DatePickerDayContainer.js.map